var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83.4 97.4",
    style: {
      enableBackground: "new 0 0 83.4 97.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0D3547;}\n\t.st1{opacity:5.000000e-02;}\n\t.st2{fill:#010101;}\n\t.st3{fill:#2174A5;}\n\t.st4{opacity:0.1;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.9,37.9c-0.2,0-0.4-0.1-0.4-0.3c-0.1-0.2,0-0.5,0.2-0.7c0.1-0.1,14.9-7.9,15.9-21.6c0-0.3,0.3-0.5,0.5-0.5 c0.3,0,0.5,0.3,0.5,0.5c-1,14.3-16.2,22.4-16.4,22.5C57,37.9,57,37.9,56.9,37.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 33.2,
    cy: 92.7,
    rx: 25.5,
    ry: 4.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,93C13.7,93,13.7,93,13.7,93c-0.3,0-0.5-0.2-0.5-0.5c0.5-11.9,9.6-40.3,9.7-40.5c0.1-0.3,0.4-0.4,0.6-0.3 c0.3,0.1,0.4,0.4,0.3,0.6c-0.1,0.3-9.2,28.5-9.7,40.3C14.2,92.8,14,93,13.7,93z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.7,93c-0.3,0-0.5-0.2-0.5-0.5c-0.5-11.8-9.6-40-9.7-40.3c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3 c0.1,0.3,9.2,28.6,9.7,40.5C49.2,92.8,49,93,48.7,93C48.7,93,48.7,93,48.7,93z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,54.5c-2.1,0-4.3-0.9-5.2-3.6c-1.3-3.9-1.1-6.9,0.7-9c3.7-4.3,12.9-2.6,13.2-2.5c0.3,0.1,0.4,0.3,0.4,0.6 c-0.1,0.3-0.3,0.4-0.6,0.4c-0.1,0-8.9-1.6-12.3,2.2c-1.5,1.8-1.7,4.5-0.5,8c0.9,2.8,3.6,3.3,5.7,2.8c2-0.5,4-2,3.8-3.9 c-0.1-1.1-0.7-1.9-1.6-2C9,47.3,8.3,47.6,8,48c-0.2,0.4,0,1,0.5,1.6c0.2,0.2,0.2,0.5,0,0.7c-0.2,0.2-0.5,0.2-0.7,0 C6.6,49,7,47.9,7.2,47.5c0.5-0.8,1.6-1.3,2.7-1.1c1.3,0.2,2.2,1.3,2.4,2.9c0.3,2.5-2.1,4.4-4.5,5C7.2,54.4,6.6,54.5,6,54.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 33,
    cy: 29.8,
    r: 25.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.9,34.2c-2,8.6-9.7,15-18.9,15c-10.7,0-19.4-8.7-19.4-19.4c0-10.7,8.7-19.4,19.4-19.4 c9.2,0,16.9,6.4,18.9,15c-2.3,0.1-4.1,2.1-4.1,4.4C47.7,32.2,49.6,34.1,51.9,34.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.4,39.8C52.5,48.9,43.5,55.3,33,55.3c-10.5,0-19.5-6.4-23.4-15.4c5.1,7.5,13.7,12.4,23.4,12.4 C42.7,52.3,51.3,47.3,56.4,39.8z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 27,
    cy: 18.8,
    r: 1.1
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 39,
    cy: 18.8,
    r: 1.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33,43.4c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4S34.3,43.4,33,43.4z M33,39.6 c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S33.8,39.6,33,39.6z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33,34.4c-0.3,0-0.5-0.2-0.5-0.5v-15c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v15C33.5,34.1,33.3,34.4,33,34.4z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 33,
    cy: 6.1,
    rx: 3.9,
    ry: 1
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,6.6C33,6.6,32.9,6.6,33,6.6c-0.3,0-0.5-0.3-0.5-0.5V0.5C32.5,0.2,32.7,0,33,0s0.5,0.2,0.5,0.5v3.8 c0.7-0.9,1.9-1.9,3.7-2.2c0.3,0,0.5,0.1,0.6,0.4S37.6,3,37.3,3.1c-2.8,0.4-3.8,3.1-3.9,3.2C33.4,6.5,33.2,6.6,33,6.6z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,6.6c-0.2,0-0.4-0.1-0.5-0.3c0-0.1-1-2.8-3.9-3.2c-0.3,0-0.5-0.3-0.4-0.6c0-0.3,0.3-0.5,0.6-0.4 c1.8,0.3,3,1.3,3.7,2.2V0.5C32.5,0.2,32.7,0,33,0s0.5,0.2,0.5,0.5v5.6C33.5,6.4,33.3,6.6,33,6.6C33,6.6,33,6.6,33,6.6z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.1,0.5c0.6-0.8,1.8-0.6,2.2,0.3l3.5,8.5l3.5,8.5c0.4,0.9-0.4,1.9-1.4,1.8l-9.1-1.2l-9.1-1.2 c-1-0.1-1.5-1.3-0.8-2.1l5.6-7.2L74.1,0.5z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.9,19.5l-9-1.2l-8-1.1l15,0.2c0.5,0,0.8-0.4,0.7-0.9L76.3,0.7c0,0,0,0.1,0.1,0.1l3.5,8.5l3.5,8.5 C83.6,18.7,82.9,19.7,81.9,19.5z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M73.5,10.9l0-2.8c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.6,0.3-0.7C74.1,6,74.3,5.9,74.6,6c0.3,0,0.5,0.2,0.6,0.4 c0.1,0.2,0.1,0.6,0.1,1c0,0.3-0.1,0.5-0.1,0.8L74.7,11c-0.1,0.3-0.1,0.6-0.2,0.8C74.4,12,74.2,12,74,12c-0.2,0-0.3-0.1-0.4-0.3 C73.5,11.5,73.5,11.3,73.5,10.9z M73.8,14.8c-0.2,0-0.4-0.1-0.6-0.3C73,14.3,73,14.1,73,13.8c0-0.2,0.1-0.4,0.3-0.6 c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.3c0.2,0.2,0.2,0.4,0.2,0.6c0,0.3-0.1,0.5-0.3,0.6C74.2,14.8,74,14.8,73.8,14.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1d7b042c326583df9750663fdbcf95d7.svg";
export { ForwardRef as ReactComponent };